import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';
import { useSession } from '@/contexts/SessionContext';

/**
 * Landing route for the Google OAuth redirect. Clerk completes the sign-in
 * (including first-time sign-up transfer); ClerkSessionProvider then
 * exchanges the new Clerk session for the internal JWT. Once that exchange
 * has produced a ready session, leave for the welcome view.
 */
export default function SsoCallback() {
  const session = useSession();

  if (session.status === 'ready') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#161616]">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#E02125]" />
      <AuthenticateWithRedirectCallback
        signInFallbackRedirectUrl="/"
        signUpFallbackRedirectUrl="/"
      />
    </div>
  );
}
